var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 144 144",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st2{fill:#347056}.st3,.st4{fill:none;stroke:#175b3e;stroke-width:3;stroke-linecap:round;stroke-miterlimit:2.6131}.st4{stroke-width:2;stroke-linejoin:round}.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#2ec986}.st7{stroke:#175b3e;stroke-width:2;stroke-miterlimit:2.6131}.st12,.st7,.st8,.st9{fill:none;stroke-linecap:round}.st8{stroke:#2ec986;stroke-miterlimit:2.6131;stroke-width:3}.st12,.st9{stroke-width:2}.st9{stroke-miterlimit:2.6131;stroke:#fff}.st12{stroke:#42a87c}.st14{fill:#2ec986}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "object"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.4 46.2H77.5c-1.2 0-3-.8-3.7-1.8l-2.5-3c-1.3-1.6-3.9-2.9-6.1-2.9H26.4c-2.5 0-4.5 2-4.5 4.5v60c0 2.5 2 4.5 4.5 4.5h94c2.5 0 4.5-2 4.5-4.5V50.7c0-2.5-2-4.5-4.5-4.5z",
    opacity: 0.19,
    fill: "#2ec986"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 101c0 1.7-1.3 3-3 3H24c-1.6 0-3-1.3-3-3V41c0-1.7 1.4-3 3-3h38.8c1.6 0 3.9 1 4.9 2.3l2.5 3c1 1.3 3.2 2.3 4.9 2.3H118c1.7 0 3 1.4 3 3V101z",
    fill: "#e6f9f0"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21,
    cy: 66.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21,
    cy: 58.8,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 21,
    cy: 51.2,
    r: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M121 69v32c0 1.7-1.3 3-3 3H24c-1.6 0-3-1.3-3-3V72.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M122.5 59.3h-3M122.5 64.6h-3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M21 45.1V41c0-1.7 1.4-3 3-3h38.8c1.6 0 3.9 1 4.9 2.3l2.5 3c1 1.3 3.2 2.3 4.9 2.3H118c1.7 0 3 1.4 3 3v6.2"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M53.5 70.9c-6.7 0-12.3 14.3-13.9 18.8-.2.7.3 1.3.9 1.3h26c.7 0 1.2-.7.9-1.3-1.5-4.5-7.2-18.8-13.9-18.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st6",
    cx: 53.5,
    cy: 63.6,
    r: 7.2
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M73.1 63.9h33.7M73.1 73.1h24.1M73.1 82.4h30.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M58.5 99.1v11M86.7 99.1v11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M27.4 55.2v42.9M27.4 43.3v6.8"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f6fdfa",
    stroke: "#175b3e",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 2.613
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.4 88.8S58 68.6 50 68.6 35.6 88.8 35.6 88.8h28.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 61.4,
    r: 7.2,
    fillRule: "evenodd",
    clipRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "sparkles"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M125.9 19c-1 2-3.1 3.4-5.3 3.6M116.4 21.9c-2-1-3.4-3.1-3.6-5.3M113.5 12.4c1-2 3.1-3.4 5.3-3.6M123 9.5c2 1 3.4 3.1 3.6 5.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.8 121.7c-.7 0-3.2 2.5-3.2 3.2 0-.7-2.5-3.2-3.2-3.2.7 0 3.2-2.5 3.2-3.2.1.8 2.6 3.2 3.2 3.2z",
    fill: "#dfab29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M25.8 20.4c-.5 0-2.4 1.9-2.4 2.4 0-.5-1.9-2.4-2.4-2.4.5 0 2.4-1.9 2.4-2.4 0 .6 1.9 2.4 2.4 2.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 122.2,
    cy: 124.4,
    r: 3.2,
    opacity: 0.15,
    fill: "#2ec986"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 120.8,
    cy: 123,
    r: 3.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 23.3,
    cy: 131.9,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 132.9,
    cy: 40.7,
    r: 1.5,
    fill: "#175b3e"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 7.3,
    cy: 93.9,
    r: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1b8b289bdaec0b1ba1227ea2efd5d614.svg";
export { ForwardRef as ReactComponent };